<template>
  <div class="transfer">
    <PageHeader :title="$t('划转')" url="/myassets"></PageHeader>
    <section class="content_auto">
      <div class="warning-box">
        <img :src="require('@/assets/images/warning1.png')" />
        <span>
          <!-- 当您持有合约仓位时，为了避免划转合约账户资产后致保证金不足触发强平机制，系统会限制划转数量不得高于可划转数量的50%。 -->
          {{
            $t(
              '当您持有合约仓位时，为了避免划转合约账户资产后致保证金不足触发强平机制，系统会限制划转数量不得高于可划转数量的50%。'
            )
          }}
        </span>
      </div>

      <div class="form-box">
        <div class="form-item">
          <div class="form-item--label">{{ $t('选择币种：') }}</div>
          <div class="form-item--content currency-box">
            <div
              v-for="item in holdingData"
              :key="item.currency"
              class="currency-item"
              :class="{ active: item.currencyName === checkedCurrency }"
              @click="checkedCurrencyChangedEvent(item.currencyName)"
            >
              {{ item.currencyName }}
            </div>
          </div>
        </div>
        <div class="form-item">
          <div class="form-item--label">{{ $t('从：') }}</div>
          <div class="form-item--content">
            {{ $t(walletConfig.fromWallet) }}
          </div>
        </div>
        <div class="form-item">
          <div class="form-item--label"></div>
          <div class="form-item--content transfer-img">
            <img
              :src="require('@/assets/images/transfer.png')"
              @click=";(direction = direction ^ 1), (ammount = '')"
            />
          </div>
        </div>
        <div class="form-item">
          <div class="form-item--label">{{ $t('划转至：') }}</div>
          <div class="form-item--content to-wallet">
            {{ $t(walletConfig.toWallet) }}
          </div>
        </div>
        <div class="form-item">
          <div class="form-item--label">{{ $t('划转数量：') }}</div>
          <div class="form-item--content">
            <div class="ammount-box">
              <div class="input-box">
                <input
                  v-model="ammount"
                  :placeholder="$t('请输入数量')"
                  @input="handleInput(ammount, 'ammount', ammountDigit)"
                  @blur="ammount = +ammount ? `${+ammount}` : ''"
                />
                <span>{{ checkedCurrency }}</span>
              </div>
              <div class="available-box">
                <span>
                  {{ $t('可划转数量：') }}
                </span>
                <span>
                  {{ availableAmmount }}
                </span>
                <span
                  @click="
                    handleInput(
                      +availableAmmount ? `${+availableAmmount}` : '',
                      'ammount',
                      ammountDigit
                    )
                  "
                >
                  {{ $t('全部') }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="commit-box">
        <Button type="primary" @click="commitTransferEvent">
          {{ $t('确定') }}
        </Button>
      </div>
      <div class="table-container">
        <h4>{{ $t('划转记录') }}</h4>
        <Table
          :columns="columns"
          :data="tableList"
          :loading="loading"
          :noDataText="`<div class='no_data'>
        <img  src='${require('@/assets/images/no-data.png')}'>
      <span class='text'> ${$t('暂无记录')} </span>
  </div>`"
        >
        </Table>
        <div class="page-box">
          <Page
            v-if="total > offset"
            :total="total"
            :page-size="offset"
            :model-value="start"
            show-sizer
            @on-change="pageNoChangeEvent"
            @on-page-size-change="pageSizeChangeEvent"
            @on-prev="pageNoChangeEvent"
            @on-next="pageNoChangeEvent"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { fetchHoldingData } from '@/api/contract'
import { doTransfer } from '@/api/transaction'
import { Big } from 'big.js'
import digitProcess from '@/mixin/digital-process'
import {
  ajax_getMyAssetList,
  fetchUserContractTrasferRecord,
} from '@/api/assets'
export default {
  mixins: [digitProcess],
  data() {
    return {
      holdingData: [],
      coinsAsset: [],
      checkedCurrency: this.$route.params.currency || '',
      direction: 1, //  0 币币->合约 1 合约->币币
      ammount: '',
      loading: true,
      tableList: [],
      columns: [
        { title: this.$t('时间'), key: 'time' },
        {
          title: this.$t('数量'),
          render: (h, { row: { num, type } }) => {
            const style = `color:${{ 0: '#E03611 ', 1: '#00B574' }[type]}`
            const attrs = { style }
            return h('span', { attrs }, `${{ 0: '-', 1: '+' }[type]}${num}`)
          },
        },
        {
          title: this.$t('划转方向'),
          render: (h, { row: { type } }) => {
            return h('span', { 0: this.$t('转出'), 1: this.$t('转入') }[type])
          },
        },
        {
          title: this.$t('状态'),
          render: (h) => {
            return h('span', this.$t('已完成'))
          },
        },
      ],
      total: 0,
      start: 1,
      offset: 10,
      params: undefined,
    }
  },
  computed: {
    walletConfig() {
      const wallets = ['币币钱包', '合约钱包']
      return {
        fromWallet: wallets[this.direction],
        toWallet: wallets[this.direction ^ 1],
      }
    },
    contractAvailableAmmount() {
      if (!this.holdingData.length) return '--'
      const currency = this.holdingData.find(
        (item) => item.currencyName === this.checkedCurrency
      )
      return currency?.available || '0'
    },
    currencyInfo() {
      return this.coinsAsset.find(
        (item) => item.coinName === this.checkedCurrency
      )
    },
    coinsAvailableAmmount() {
      if (!this.coinsAsset.length) return '--'
      return this.currencyInfo?.amountUsable || '0'
    },
    // 数量精度
    ammountDigit() {
      return this.currencyInfo?.showDigits || 4
    },
    availableAmmount() {
      return this.direction
        ? this.contractAvailableAmmount
        : this.coinsAvailableAmmount
    },
  },
  watch: {
    checkedCurrency: {
      handler() {
        this.getTableData()
      },
      immediate: true,
    },
  },
  mounted() {
    this.getCoinsAsset()
    this.getHoldingData()
  },
  methods: {
    async commitTransferEvent() {
      if (!+this.ammount) {
        return this.$Message.warning(this.$t('请输入币种数量'))
      }
      if (Big(this.ammount).gt(this.availableAmmount)) {
        return this.$Message.warning(this.$t('余额不足'))
      }
      try {
        this.loading = true
        await doTransfer({
          coinCode: this.checkedCurrency,
          num: this.ammount,
          type: this.direction,
        })

        this.$Message.success(this.$t('操作成功'))
        this.getCoinsAsset()
        this.getHoldingData()
        this.start = 1
        this.offset = 10
        this.getTableData()

        this.dialogVisible = false
      } finally {
        this.loading = false
      }
    },
    checkedCurrencyChangedEvent(currencyName) {
      this.start = 1
      this.offset = 10
      this.checkedCurrency = currencyName
      this.ammount = ''
    },
    pageNoChangeEvent(start) {
      this.start = start
      this.getTableData()
    },
    pageSizeChangeEvent(offset) {
      this.offset = offset
      this.getTableData()
    },
    async getTableData() {
      if (!this.checkedCurrency) return
      const params = {
        start: this.start - 1,
        offset: this.offset,
        coinCode: this.checkedCurrency,
      }
      this.params = JSON.stringify(params)
      this.loading = true
      const { item, count } = await fetchUserContractTrasferRecord(params)
      if (this.params !== JSON.stringify(params)) return
      this.tableList = item
      this.total = count
      this.loading = false
    },
    async getHoldingData() {
      this.holdingData = await fetchHoldingData({ holdStatus: 'HOLDING' })
      if (this.holdingData.length && !this.checkedCurrency) {
        this.checkedCurrency = this.holdingData[0].currencyName
      }
    },
    async getCoinsAsset() {
      const { item } = await ajax_getMyAssetList({
        start: 0,
        offset: 9999,
      })
      this.coinsAsset = item
    },
  },
}
</script>
<style scoped lang="less">
.transfer {
  padding-bottom: 40px;
  .warning-box {
    background-color: #fff4ed;
    padding: 0 16px;
    display: flex;
    height: 48px;
    align-items: center;
    margin-bottom: 25px;
    img {
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }
    span {
      font-size: 12px;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.9);
    }
  }
  .form-box {
    display: inline-table;
    .form-item {
      display: table-row;

      &--label,
      &--content {
        display: table-cell;
        padding: 12.5px 0;
        font-size: 14px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.9);
      }
      &--label {
        text-align: right;
      }
      &--content {
        padding-left: 30px;
        width: fit-content;

        &.currency-box {
          display: flex;
          .currency-item {
            height: 34px;
            line-height: 34px;
            padding: 0 15px;
            border: 1px solid rgba(0, 0, 0, 0.1);
            border-radius: 4px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.9);
            cursor: pointer;
            &:not(:first-child) {
              margin-left: 20px;
            }
            &.active {
              background: #1c1b1b;
              border: none;
              color: #ffffff;
            }
          }
        }
        &.transfer-img {
          padding-top: 0;
          padding-bottom: 0;
          img {
            width: 25px;
            height: 25px;
            cursor: pointer;
          }
        }
        .ammount-box {
          .input-box {
            height: 32px;
            border-radius: 5px;
            border: 1px solid rgba(0, 0, 0, 0.1);
            padding-right: 10px;
            input {
              border: none;
              outline: none;
              height: 100%;
              padding: 0 10px;
              border-radius: 5px;
              font-size: 14px;
              font-weight: 400;
              &::placeholder {
                color: rgba(0, 0, 0, 0.3);
              }
            }
            span {
              font-size: 14px;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.9);
            }
          }
          .available-box {
            height: 24px;
            line-height: 24px;
            font-size: 12px;
            span {
              &:nth-child(1) {
                color: rgba(0, 0, 0, 0.6);
              }
              &:nth-child(2) {
                font-weight: 600;
              }
              &:nth-child(3) {
                color: #3890f9;
                cursor: pointer;
              }
            }
          }
        }
      }
    }
  }
  .commit-box {
    margin-top: 60px;
    margin-bottom: 80px;
    text-align: center;
    button {
      padding: 0 280px;
      height: 60px;
      font-size: 16px;
    }
  }
  .table-container {
    h4 {
      font-size: 16px;
      font-weight: 500;
      color: #333333;
      line-height: 19px;
      padding-bottom: 14px;
    }
    .ivu-table-wrapper {
      ::v-deep .ivu-spin-fix {
        // background: rgba(#0a0a0c, 0.8);
        .ivu-spin-dot {
          background-color: #fff;
        }
      }
      ::v-deep .ivu-table {
        background: none;

        &::before {
          content: none;
        }
        .ivu-table-header {
          table {
            height: 40px;
            border-collapse: unset;
          }
          th {
            background: #ffffff;
            font-size: 14px;
            font-weight: 500;
            color: #616888;
            border-top: 1px solid #e8e8e8;
            border-top: 1px solid #e8e8e8;
          }
        }
        .ivu-table-body {
          td {
            background: #ffffff;
            font-size: 14px;
            color: #333333;
            border-bottom-color: #e8e8e8;
            padding: 10px 0;
          }
        }
        .ivu-table-tip {
          td {
            background: none;
            border: none;
          }
          span:not(.text) {
            position: relative;
            display: inline-block;
            height: 400px;
            width: 100%;
            .no_data {
              background-color: #ffffff;
              width: 100%;
              position: absolute;
              left: 0;
              right: 0;
              top: 0;
              bottom: 0;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              img {
                width: 160px;
                height: 160px;
                margin-bottom: 10px;
              }
              .text {
                font-size: 14px;
                font-weight: 400;
                color: #969799;
              }
            }
          }
        }
      }
    }
  }
  .page-box {
    margin-top: 20px;
    text-align: center;
  }
}
</style>
